import { keyframes } from 'styled-components';

export const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const rotate = (centered) => keyframes`
  0% {
    transform: ${centered ? 'translate3d(-50%, -50%, 0) ' : ''}rotate(0deg);
  }
  100% {
    transform: ${centered ? 'translate3d(-50%, -50%, 0) ' : ''}rotate(360deg);
  }
`;
